import React, { useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import PageTop from "../../components/PageTop/PageTop";
import TermsAndCondition from "../../components/TermsAndCondition/TermsAndCondition";
import MainNav from "../../shared/MainNav/MainNav";

export default function Terms() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      <MainNav title="Terms and Conditions" />
      <PageTop pageTitle="Terms And Conditions" />
      <TermsAndCondition />
      <Footer />
    </>
  );
}
